import DqrController from "./controllers/DqrController";
import Layout from "lib/dqr/views/DataQualityReportLayout";

class DataQualityReportModule {
    constructor(application) {
        return application.module(
            "DataQualityReport",
            function (mod, app, Backbone, Marionette, $, _) {
                mod.startWithParent = false;

                mod.addInitializer(function (application) {
                    mod.model = application.model;

                    mod.controller = new DqrController(mod);

                    mod.layout = new Layout({
                        model: application.model.get("dataQualityReport"),
                    });
                    mod.layout.render();

                    // Freeze the object
                    //Object.freeze? this
                });

                mod.on("start", () =>
                    mod.controller.dispatch("load:dqr_home"));

                mod.addFinalizer(() => {
                    mod.controller.stopListening();
                    delete mod.controller;
                });
            },
        );
    }
}

export default DataQualityReportModule;



// WEBPACK FOOTER //
// ./app/lib/dqr/DataQualityReportModule.js